document.addEventListener('DOMContentLoaded', function () {
  const titles = document.querySelectorAll('.product-video-tit');
  const videos = document.querySelectorAll('.yut-lsa');

  titles.forEach((title, index) => {
    title.addEventListener('click', () => {
      titles.forEach(t => t.classList.remove('active'));
      videos.forEach(v => v.classList.remove('active'));
      title.classList.add('active');
      if (videos[index]) {
        videos[index].classList.add('active');
      }
    });
  });
});

let videos = document.querySelectorAll('[data-youtube]');
for (let video of videos) {
	let id = new URL(video.href).searchParams.get('v');
	video.setAttribute('data-youtube', id);
	video.setAttribute('role', 'button');
	video.innerHTML =
		`<img srcset="https://img.youtube.com/vi/${id}/maxresdefault.jpg" loading="lazy"><svg class="video-play" height="100%" width="100%" viewBox="0 0 68 48">
                      <path d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path>
                    </svg><br>
		${video.textContent}`;
}
function clickHandler (event) {
	let link = event.target.closest('[data-youtube]');
	if (!link) return;
	event.preventDefault();
	let id = link.getAttribute('data-youtube');
	let player = document.createElement('div');
	player.innerHTML = `<div class="video-wrapper"><iframe  src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
	link.replaceWith(player);

}
document.addEventListener('click', clickHandler);   
